import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { CommonDataService } from '../../services/common-data.service';
import { GraphqlService } from '../../services/graphql.service';

@Component({
  selector: 'app-what-links-here',
  templateUrl: './what-links-here.component.html'
})
export class WhatLinksHereComponent implements OnInit {

  @Output() myEvent = new EventEmitter<string>();

  urlLink: string;
  what_links_header: string;
  what_links_body: string;
  no_links_available:string;

  links_to_fasb;
  links_to_sec;

  whatLinksHereObject: {
    id: string,
    breadcrumbPath: string,
    subsections: {
      subsectionTitle: string,
      subsectionLinks: {
        linkTitle: string,
        paragraphNumber: string,
        publicationId: string,
        topicId: string
        pageInfoId: string,
        pageName: string
      }[]
    }[]
  }[] = [];

  constructor(private graphQlService: GraphqlService, private router: Router, private commonDataService: CommonDataService) {
  }

  normalPageId: string = "";
  secPageId: string = "";
  normalContentPresent: boolean = false;
  secContentPresent: boolean = false;
  invokedFromToc: boolean = false;
  parameter; 
  ngOnInit(): void {
    this.urlLink = this.router.url;
    this.commonDataService.whatLinksHereParams.subscribe(params => { this.parameter = params.split("-"); })
    this.commonDataService.hasActualContent.subscribe(data => { this.normalContentPresent = data;  })
    this.commonDataService.hasSecContent.subscribe(data => { this.secContentPresent = data; });
    this.commonDataService.invokedFromTOC.subscribe(data => { this.invokedFromToc = data; });
    if (this.parameter.length > 2) {
      if (this.parameter[2].startsWith('S')) {
        this.normalPageId = this.parameter[2].substring(1);
        this.secPageId = this.parameter[2];
      }
      else {
        this.normalPageId = this.parameter[2];
        this.secPageId = "S" + this.parameter[2];
      }
    }
    else if (this.parameter.length == 1) {
      this.normalPageId = "";
      if (this.parameter[0].startsWith("S")) {
        this.secPageId = "";
      } else {
        this.secPageId = null;
      }
    }
    else {
        this.normalPageId = "";
        this.secPageId = "";
    }

    this.getWhatLinksHereLables();
  }
  //grnArr = [];
  linkArrayNormal: any[] = [];
  linkArraySec: any[] = [];
  getWhatLinksHereLables() {
    this.commonDataService.showLoader.next(true);
    forkJoin([
      this.graphQlService.getWhatLinksHereLabels(),
      this.graphQlService.getWhatLinksHereContent(this.parameter[0], this.parameter[1], this.normalPageId),
      this.graphQlService.getWhatLinksHereContent(this.parameter[0], this.parameter[1], this.secPageId)
    ]).subscribe(([WhatLinkslabels, WhatLinksNormaldata, WhatLinksSecdata]) => {
      //labels
      let labels = WhatLinkslabels.content.data.labels;
      this.what_links_header = labels.filter(x => x.key === "what_links_header").map(y => y.value);
      this.what_links_body = labels.filter(x => x.key === "what_links_body").map(y => y.value);
      this.links_to_fasb = labels.filter(x => x.key === "links_to_fasb").map(y => y.value);
      this.links_to_sec = labels.filter(x => x.key === "links_to_sec").map(y => y.value);
      this.no_links_available=labels.filter(x => x.key === "what_links_no_links_text").map(y => y.value);
      
      let sourceNormal = WhatLinksNormaldata.hits.hitsList.filter(x => x.source.contentType != "SEC");
     
      if (sourceNormal.length > 0) {
        sourceNormal.sort((a, b) => {
          if (!a.source.isGlossary && !b.source.isGlossary) {
            if (a.source.sourceTopicId === b.source.sourceTopicId) {
              if (a.source.sourceSubtopicId === b.source.sourceSubtopicId) {
                if (a.source.sourceSectionId === b.source.sourceSectionId) {
                  if (parseInt(a.source.sourceParagraphId?.split("-")[1].replace(/[A-Z]/g, '')) === parseInt(b.source.sourceParagraphId?.split("-")[1].replace(/[A-Z]/g, ''))) {
                    return (a.source.sourceParagraphId?.split("-")[1].replace(/[0-9]/g, '')) < (b.source.sourceParagraphId?.split("-")[1].replace(/[0-9]/g, '')) ? -1 : 1;
                  }
                  else {
                    return parseInt(a.source.sourceParagraphId?.split("-")[1].replace(/[A-Z]/g, '')) < parseInt(b.source.sourceParagraphId?.split("-")[1].replace(/[A-Z]/g, '')) ? -1 : 1
                  }
                }
                else {
                  return a.source.sourceSectionId < b.source.sourceSectionId ? -1 : 1
                }
              }
              else {
                return a.source.sourceSubtopicId < b.source.sourceSubtopicId ? -1 : 1
              }
            } else {
              return a.source.sourceTopicId < b.source.sourceTopicId ? -1 : 1
            }
          }
          else if (!a.source.isGlossary && b.source.isGlossary) {
            return -1;
          }
          else if (a.source.isGlossary && !b.source.isGlossary) {
            return 1;
          }
          else if (a.source.isGlossary && b.source.isGlossary) {
            return a.source.glossaryName < b.source.glossaryName ? -1 : 1;
          }
        })
        //debugger;
        let groups = {};
        for (let i = 0; i < sourceNormal.length; i++) {
          let groupName = '';
          
          if (this.invokedFromToc) {
            groupName = sourceNormal[i].source.targetParagraphId == null && sourceNormal[i].source.targetSectionId == null && sourceNormal[i].source.targetSubtopicId == null ? "1" : ((sourceNormal[i].source.targetParagraphId == null && sourceNormal[i].source.targetSectionId == null) ? sourceNormal[i].source.targetTopicId + "-" + sourceNormal[i].source.targetSubtopicId + "-0" : sourceNormal[i].source.targetTopicId + "-" + sourceNormal[i].source.targetSubtopicId + "-" + (sourceNormal[i].source.targetParagraphId == null ? sourceNormal[i].source.targetSectionId : sourceNormal[i].source.targetParagraphId));
            //groupName = groupName.replace("-null", "-0");
           
          }
          else {
            groupName = sourceNormal[i].source.targetParagraphId == null ? sourceNormal[i].source.targetSectionId == null ? "1" : "2" : sourceNormal[i].source.targetParagraphId;
          }
          if (!groups[groupName]) {
            groups[groupName] = [];
          }
          if (sourceNormal[i].source.isGlossary && groups[groupName].length > 0) {
            if (!(groups[groupName].some(source => source.glossaryName == sourceNormal[i].source.glossaryName))) {
              groups[groupName].push(sourceNormal[i].source);
            }
          }
          else {
            groups[groupName].push(sourceNormal[i].source);
          }
        }
        this.linkArrayNormal = [];
        for (let groupName in groups) {
          this.linkArrayNormal.push({ group: groupName.replace('-null', ''), source: groups[groupName] });
          //this.grnArr.push(groupName);
        }
        //console.log(this.grnArr);
        if (this.invokedFromToc) {
          this.linkArrayNormal.sort(this.customSort);
        } else {
          this.linkArrayNormal.sort((first, second) => this.sortAlphaNum(first.group, second.group) ? -1 : 1);
        }

      }
      if (this.linkArrayNormal.length > 0) {
        this.normalContentPresent = true;
      }
      let sourceSec = WhatLinksSecdata.hits.hitsList.filter(x => x.source.contentType == "SEC");
      //console.log(sourceSec);
      if (sourceSec.length > 0) {
        sourceSec.sort((a, b) => {
          if (!a.source.isGlossary && !b.source.isGlossary) {
            if (a.source.sourceTopicId === b.source.sourceTopicId) {
              if (a.source.sourceSubtopicId === b.source.sourceSubtopicId) {
                if (a.source.sourceSectionId === b.source.sourceSectionId) {
                  if (parseInt(a.source.sourceParagraphId?.split("-")[1]?.replace(/[A-Z]/g, '')) === parseInt(b.source.sourceParagraphId?.split("-")[1]?.replace(/[A-Z]/g, ''))) {
                    return (a.source.sourceParagraphId?.split("-")[1]?.replace(/[0-9]/g, '')) < (b.source.sourceParagraphId?.split("-")[1]?.replace(/[0-9]/g, '')) ? -1 : 1;
                  }
                  else {
                    return parseInt(a.source.sourceParagraphId?.split("-")[1]?.replace(/[A-Z]/g, '')) < parseInt(b.source.sourceParagraphId?.split("-")[1]?.replace(/[A-Z]/g, '')) ? -1 : 1
                  }
                }
                else {
                  return a.source.sourceSectionId < b.source.sourceSectionId ? -1 : 1
                }
              }
              else {
                return a.source.sourceSubtopicId < b.source.sourceSubtopicId ? -1 : 1
              }
            } else {
              return a.source.sourceTopicId < b.source.sourceTopicId ? -1 : 1
            }
          }
          else if (!a.source.isGlossary && b.source.isGlossary) {
            return -1;
          }
          else if (a.source.isGlossary && !b.source.isGlossary) {
            return 1;
          }
          else if (a.source.isGlossary && b.source.isGlossary) {
            return a.source.glossaryName < b.source.glossaryName ? -1 : 1;
          }
        })

        let groupsSec = {};
        for (let i = 0; i < sourceSec.length; i++) {
          let groupName = '';
          if (this.invokedFromToc) {
            //groupName = sourceSec[i].source.targetParagraphId == null ? sourceSec[i].source.targetSectionId == null ? "1" : "2" : sourceSec[i].source.targetTopicId + sourceSec[i].source.targetSubtopicId + sourceSec[i].source.targetParagraphId;
            groupName = sourceSec[i].source.targetParagraphId == null && sourceSec[i].source.targetSubtopicId == null && sourceSec[i].source.targetSectionId == null ? "1" : ((sourceSec[i].source.targetParagraphId == null && sourceSec[i].source.targetSectionId == null) ? sourceSec[i].source.targetTopicId + "-" + sourceSec[i].source.targetSubtopicId + "-0" : sourceSec[i].source.targetTopicId + "-" + sourceSec[i].source.targetSubtopicId + "-" + (sourceSec[i].source.targetParagraphId == null ? sourceSec[i].source.targetSectionId : sourceSec[i].source.targetParagraphId));
                      }
          else {
            groupName = sourceSec[i].source.targetParagraphId == null ? "" : sourceSec[i].source.targetParagraphId;
          }
          groupName = groupName.replace("-null", "");
          if (!groupsSec[groupName]) {
            groupsSec[groupName] = [];
          }

          if (sourceSec[i].source.isGlossary && groupsSec[groupName].length > 0) {
            if (!(groupsSec[groupName].some(source => source.glossaryName == sourceSec[i].source.glossaryName))) {
              groupsSec[groupName].push(sourceSec[i].source);
            }
          }
          else {
            groupsSec[groupName].push(sourceSec[i].source);
          }
        }
        this.linkArraySec = [];
        //this.grnArr = [];
        for (let groupName in groupsSec) {
          this.linkArraySec.push({ group: groupName, source: groupsSec[groupName] });
          //this.grnArr.push(groupName);
          
        }
        /*console.log(this.grnArr);*/
        if (this.invokedFromToc) {
          //this.linkArraySec = this.sortArrayAscending( this.linkArraySec);
          this.linkArraySec.sort(this.sortSec); 
        } else {
          this.linkArraySec.sort((first, second) => this.sortAlphaNum(first.group, second.group) ? -1 : 1);
        }
      }
      if (this.linkArraySec.length > 0) {
        this.secContentPresent = true;
      }
      this.commonDataService.showLoader.next(false);
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }

  

  sortAlphaNum(a, b) {
    a = a == "" ? a : a.split("-")[1];
    b = b == "" ? b : b.split("-")[1];
    if (a == "") {
      return true;
    }
    else if (b == "") { return false; }
    else {
      var aA = parseInt(a?.replace(/[A-Z]/g, ''));
      var bA = parseInt(b?.replace(/[A-Z]/g, ''));
      if (aA === bA) {
        let aN: number = 0;
        let bN: number = 0;
        if (a?.replace(/[0-9]/g, '') == '') { aN = 0; } else { aN = parseInt(a?.replace(/[0-9]/g, '').charCodeAt()); }
        if (b?.replace(/[0-9]/g, '') == '') { bN = 0; } else { bN = parseInt(b?.replace(/[0-9]/g, '').charCodeAt()); }
        return aN < bN;
      } else {
        return aA < bA;
      }
    }
  }

 sortArrayAscending(arr) {
   return arr.sort((a, b) => {
     
     //const aPart = a.group.split("-").length == 3 ? a.group + "-0" : a.group;
     //const bPart = b.group.split("-").length == 3 ? b.group + "-0" : b.group;
     const aParts = a.group.split(/[-A-Z]/).map(part => isNaN(part) ? part : Number(part));
     const bParts = b.group.split(/[-A-Z]/).map(part => isNaN(part) ? part : Number(part));

     for (let i = 0; i < Math.min(aParts.length, bParts.length); i++) {
       if (aParts[i] !== bParts[i]) {
         return aParts[i] < bParts[i] ? -1 : 1;
       }
     }

     return aParts.length - bParts.length;
   });
}

 customSort(a, b) {
  // Extract numeric and alphanumeric parts
   const numericPartA = a.group.replace("-S","").match(/\d+/g).map(Number);
   const numericPartB = b.group.replace("-S", "").match(/\d+/g).map(Number);
   const alphaNumericA = a.group.replace(/\d+/g, '');
   const alphaNumericB = b.group.replace(/\d+/g, '');
  
  // Compare numeric parts
  for (let i = 0; i < Math.min(numericPartA.length, numericPartB.length); i++) {
    if (numericPartA[i] !== numericPartB[i]) {
      return numericPartA[i] - numericPartB[i];
    }
  }

  // If numeric parts are equal, compare alphanumeric parts
  return alphaNumericA.localeCompare(alphaNumericB);
  }

  sortSec = (a, b) => {
    // Convert strings to comparable values based on the structure

    const extractSegments = (str) => str.match(/[^\d]+|\d+/g).map(segment => isNaN(segment) ? segment : Number(segment));

    const aValue = extractSegments(a.group);
    const bValue = extractSegments(b.group);

    // Compare each segment of the strings
    for (let i = 0; i < Math.min(aValue.length, bValue.length); i++) {
      if (aValue[i] !== bValue[i]) {
        return aValue[i] < bValue[i] ? -1 : 1;
      }
    }
    // If all segments are equal, compare the original strings
    return a.group.localeCompare(b.group);
  };

  gotoContent(target) {
    let breadcrumbPath = target?.targetTopicId + "-" + target?.targetSubtopicId + "-" + target?.targetSectionId;
    let secIdentifier = "";
    if (target != null && target.targetSectionId?.includes("S"))
      secIdentifier = "S";
    if (this.parameter.length == 1)
      breadcrumbPath = this.parameter[0];
    else if (this.parameter.length == 2)
      breadcrumbPath = this.parameter[0] + "-" + this.parameter[1];
    else if (this.parameter.length == 3)
      breadcrumbPath = this.parameter[0] + "-" + this.parameter[1] + "-" + secIdentifier + this.parameter[2];

    let publicationId = target.publication_Id;
    let topicId = target.sourceTopicDeliveryId;
    let paragraphNumber = target.sourceTopicId + "-" + target.sourceSubtopicId + "-" + target.sourceParagraphId;
    this.router.navigateByUrl(publicationId + "/" + topicId + "/" + paragraphNumber, {
      state: {
        backLabel: breadcrumbPath,
        backUrl: this.urlLink
      }
    });
    this.myEvent.emit();
  }

  gotoGlossary(target) {
    let term = target.glossaryName;
    this.router.navigateByUrl("MasterGlossary");
    this.commonDataService.glossaryTerm.next(term);
    this.myEvent.emit();
  }
}
